// https://zod.dev/ERROR_HANDLING
import { z } from "zod";

const customErrorMap: z.ZodErrorMap = (error, ctx) => {
  switch (error.code) {
    case z.ZodIssueCode.invalid_type:
      if (error.expected === "string") {
        return { message: `Alphanumeric value required` };
      }
      if (error.expected === "number") {
        return { message: `Numerical value required` };
      }
      return { message: `Wrong data type` };
    case z.ZodIssueCode.invalid_string:
      if (error.validation === "email") {
        return { message: `This email is invalid` };
      }
      if (error.validation === "ip") {
        return { message: `This IP is invalid` };
      }
      if (error.validation === "url") {
        return { message: `This url is invalid` };
      }
      break;
    case z.ZodIssueCode.too_small:
      if (error.type === "string") {
        return { message: `At least ${error.minimum} characters required` };
      }
      if (error.type === "number") {
        if (error.exact) {
          return {
            message: `The input must be exact ${error.minimum}`
          };
        }
        if (error.inclusive) {
          return {
            message: `The input must be ${
              error.inclusive ? `greater than or equal to` : `greater than`
            } ${error.minimum}`
          };
        }
      }
      if (error.type === "date") {
        if (error.exact) {
          return {
            message: `The date must be after ${error.minimum}`
          };
        }
        return {
          message: `The date must be ${
            error.inclusive ? `at least after` : `after`
          } ${error.minimum}`
        };
      }
      break;
    case z.ZodIssueCode.too_big:
      if (error.type === "string") {
        if (error.exact) {
          return {
            message: `Exact ${error.maximum} characters expercted`
          };
        }
        return {
          message: ` ${error.inclusive ? `Max or equal` : `Max`} ${
            error.maximum
          } characters allowed`
        };
      }
      if (error.type === "number") {
        if (error.exact) {
          return {
            message: `The input must be ${error.maximum}`
          };
        }
        return {
          message: `The input must be ${
            error.inclusive ? `less than or equal to` : `smaller than`
          } ${error.maximum}`
        };
      }
      if (error.type === "date") {
        if (error.exact) {
          return {
            message: `The date must be before ${error.maximum}`
          };
        }
        return {
          message: `The date must be ${
            error.inclusive ? `before or equal to` : `before`
          } ${error.maximum}`
        };
      }
      break;
  }

  // fall back to default message!
  return { message: ctx.defaultError };
};

z.setErrorMap(customErrorMap);
